<template>
  <div class="o-feed-section-content">
    <MoleculeFeedSectionContentInfo v-if="false"/>
    <MoleculeFeedProjectsSearch
      v-if="$route.name === 'projects'"
      :filter-seted="filter"
      :showed-cards="cards.length"
      :total-cards="elements.length"
      @reload="reload"
      @searchFilter="searchFilter"
    />

    <MoleculeFeedProductsSearch
      v-if="$route.name === 'products'"
      :filter-seted="filterProducts"
      :showed-cards="cards.length"
      :total-cards="elements.length"
      @reloadProducts="reloadProducts"
      @searchFilterProducts="searchFilterProducts"
    />

    <draggable
      v-model="cards"
      animation="500"
      class="o-feed-section-content-cards"
      :class="[$route.name === 'products' ? 'provisional-margin' : '', 'o-feed-section-content-cards']"
      :disabled="disabledDragg"
      fallback-class="display-none"
      :fallback-on-body="true"
      :force-fallback="true"
      ghost-class="draggin-element"
      draggable=".draggable-element"
      handle=".a-list-element-actions-draggable"
      :pull="true"
      :put="false"
      :scroll="true"
      :scroll-sensitivity="50"
      @change="updateProductosOrdenar"
    >
      <router-link
        v-for="(element) in cards"
        :key="element.id"
        class="draggable-element"
        tag="div"
        :to="$route.name === 'products'
          ? `/${$t('rPaths.product')}/${element.id}/${$t('mEditionMenu.product.card.subject')}`
          : ($route.name === 'projects' && element.tipo === 0
            ? `/${$t('rPaths.asset')}/${element.id}/${$t('mEditionMenu.asset.card.subject')}`
            : `/${$t('rPaths.map')}/${element.id}/${$t('mEditionMenu.map.card.subject')}`)"
      >
        <MoleculeFeedSectionContentCard
          :is="$route.name === 'projects' || element.tarjeta === undefined
            ? moleculeCardDesign[2]
            : moleculeCardDesign[element.tarjeta]"
          :element="element"
          :hide-move-icon="hideMoveIcon"
        />
      </router-link>
      <!-- <MoleculeFeedSectionLoading
        v-show="($route.name === 'projects') && showAddingState"
        slot="footer"
      /> -->
    </draggable>
    <p
      v-if="showAddingState"
      class="font-weight-bold margin-bottom-zero text-align-center text-color-success"
      style="padding: var(--spacing-xxlarge) 0"
    >
      Cargando Datos...
    </p>

    <p
      v-if="cards.length === 0"
      class="text-align-center"
    >
      No se encontraron resultados para la búsqueda.
    </p>
    <MoleculeFeedSectionContentFooter/>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'OrganismFeedSectionContent',

  components: {
    draggable,
    MoleculeFeedSectionContentCardDesign1: () => import('@/components/molecules/MoleculeFeedSectionContentCardDesign1'),
    MoleculeFeedSectionContentFooter: () => import('@/components/molecules/MoleculeFeedSectionContentFooter'),
    MoleculeFeedSectionLoading: () => import('@/components/molecules/MoleculeFeedSectionLoading'),
    MoleculeFeedProjectsSearch: () => import('@/components/molecules/MoleculeFeedProjectsSearch'),
    MoleculeFeedProductsSearch: () => import('@/components/molecules/MoleculeFeedProductsSearch')
  },

  props: {
    elements: Array,
    showAddingState: Boolean
  },

  data () {
    return {
      academiaId: '',
      cards: [],
      disabledDragg: true,

      filter: {
        name: '',
        project_type: 11,
        sort_type: 0,
        state: [0, 1]
      },

      filterProducts: {
        name: '',
        active: -1,
        sort_type: 0,
        state: [0, 1],
        visible: [0, 1]
      },

      moleculeCardDesign: {
        2: () => import('@/components/molecules/MoleculeFeedSectionContentCardDesign2'),
        3: () => import('@/components/molecules/MoleculeFeedSectionContentCardDesign3'),
        4: () => import('@/components/molecules/MoleculeFeedSectionContentCardDesign4'),
        5: () => import('@/components/molecules/MoleculeFeedSectionContentCardDesign5'),
        6: () => import('@/components/molecules/MoleculeFeedSectionContentCardDesign6'),
        7: () => import('@/components/molecules/MoleculeFeedSectionContentCardDesign7')
      }
    }
  },

  computed: {
    hideMoveIcon () {
      if (this.$route.name === 'projects') {
        const conditionsProjects =
        this.filter.name.length === 0 &&
        this.filter.project_type !== 11 &&
        this.filter.sort_type === 1 &&
        this.filter.state.length === 2

        return !conditionsProjects
      }

      if (this.$route.name === 'products') {
        const conditionsProducts =
        this.filterProducts.name.length === 0 &&
        this.filterProducts.active === -1 &&
        this.filterProducts.sort_type === 0 &&
        this.filterProducts.state.length === 2 &&
        this.filterProducts.visible.length === 2
        return !conditionsProducts
      }

      return false
    }
  },

  watch: {
    elements: {
      handler () {
        if (this.$route.name === 'products') {
          this.searchFilterProducts(this.filterProducts)
        } else {
          this.searchFilter(this.filter)
        }
      },

      immediate: true
    }
  },

  created () {
    this.disabledDragg = !this.$route.name === 'products'
    this.academiaId = this.$store.getters.getAcademyData.id
  },

  methods: {
    reload () {
      this.filter = {
        name: '',
        project_type: 11,
        sort_type: 0,
        state: [0, 1]
      }

      this.cards = []
      // this.cards = [{ id: 'contentCardDesign1' }].concat(this.elements)
      this.cards = [...this.elements]
    },

    reloadProducts () {
      this.filterProducts = {
        name: '',
        active: -1,
        sort_type: 0,
        state: [0, 1],
        visible: [0, 1]
      }

      this.cards = []
      this.cards = [...this.elements]
    },

    searchFilter (filtros) {
      let filteredCards = []

      if (filtros.project_type !== 11) {
        filteredCards = this.elements.filter(({ tipo }) => tipo === filtros.project_type)
      } else {
        filteredCards = [...this.elements]
      }

      if (filtros.state.length === 1 && filtros.state[0] === 0) {
        filteredCards = [...filteredCards.filter(({ publicado }) => !publicado)]
      } else if (filtros.state.length === 1 && filtros.state[0] === 1) {
        filteredCards = [...filteredCards.filter(({ publicado }) => publicado)]
      }

      if (filtros.sort_type !== 0) {
        switch (filtros.sort_type) {
          case 1:
            const sinOrden = filteredCards.filter(obj => obj.orden === undefined)
            const conOrden = filteredCards.filter(obj => obj.orden !== undefined)
            sinOrden.sort((a, b) => new Date(b.fecha_alta) - new Date(a.fecha_alta))
            conOrden.sort((a, b) => a.orden - b.orden)
            filteredCards = [...sinOrden, ...conOrden]
            break
          case 2:
            filteredCards = [...filteredCards.sort((a, b) => a.titulo.localeCompare(b.titulo))]
            break
          case 3:
            filteredCards = [...filteredCards.sort((a, b) => b.preguntas_sin_responder - a.preguntas_sin_responder)]
            break
          case 4:
            filteredCards = [...filteredCards.sort((a, b) => b.alumnos - a.alumnos)]
            break
        }
      }

      if (filtros.name.length > 0) {
        filteredCards = [...filteredCards.filter(({ titulo }) => titulo.toLowerCase().includes(filtros.name.toLowerCase()))]
      }

      this.cards = []
      this.cards = [...filteredCards]

      this.filter = {
        name: filtros.name,
        project_type: filtros.project_type,
        sort_type: filtros.sort_type,
        state: filtros.state
      }
    },

    searchFilterProducts (filtros) {
      let filteredProducts = []
      if (filtros.active === 1) {
        filteredProducts = this.elements.filter(producto => producto.pago)
      } else if (filtros.active === 0) {
        filteredProducts = this.elements.filter(producto => !producto.pago)
      } else {
        filteredProducts = [...this.elements]
      }

      switch (filtros.sort_type) {
        case 0:
          if (filtros.active === -1) {
            filteredProducts = [...this.elements]
          }
          break
        case 1:
          filteredProducts = [...filteredProducts.sort((a, b) => new Date(b.fecha_alta) - new Date(a.fecha_alta))]
          break
        case 2:
          filteredProducts = [...filteredProducts.sort((a, b) => a.nombre.localeCompare(b.nombre))]
          break
      }

      if (filtros.state.length === 1 && filtros.state[0] === 0) {
        filteredProducts = [...filteredProducts.filter(({ activo }) => activo)]
      } else if (filtros.state.length === 1 && filtros.state[0] === 1) {
        filteredProducts = [...filteredProducts.filter(({ activo }) => !activo)]
      }

      if (filtros.name.length > 0) {
        filteredProducts = [...filteredProducts.filter(({ nombre }) => nombre.toLowerCase().includes(filtros.name.toLowerCase()))]
      }

      if (filtros.visible.length === 1 && filtros.visible[0] === 0) {
        filteredProducts = [...filteredProducts.filter(({ visible }) => visible)]
      } else if (filtros.visible.length === 1 && filtros.visible[0] === 1) {
        filteredProducts = [...filteredProducts.filter(({ visible }) => !visible)]
      }

      this.cards = []
      this.cards = [...filteredProducts]
      this.filterProducts = {
        name: filtros.name,
        active: filtros.active,
        sort_type: filtros.sort_type,
        state: filtros.state,
        visible: filtros.visible
      }
    },

    updateProductosOrdenar () {
      if (!this.disabledDragg) {
        this.disabledDragg = true
        if (this.$route.name === 'products') {
          this.$services.update('producto', 'updateProductosOrdenar', { elementos: this.cards })
            .then(response => {
              this.$alerts.pushAlert('oFeedSectionContent', 'updateProductosOrdenar', 'success')
              this.elements = this.cards
              this.disabledDragg = false
            })
            .catch(error => {
              console.log(error)
              this.$alerts.pushAlert('oFeedSectionContent', 'updateProductosOrdenar', 'error', 'a-alert-danger')
              this.disabledDragg = false
            })
        } else {
          this.$services.update('proyecto', 'updateProyectosOrdenar', { academia: this.academiaId, elementos: this.cards })
            .then(response => {
              this.$modal.updateData('updateElement')
              this.$alerts.pushAlert('oFeedSectionContent', 'updateProyectosOrdenar', 'success')
              this.disabledDragg = false
            })
            .catch(error => {
              console.log(error)
              this.$alerts.pushAlert('oFeedSectionContent', 'updateProyectosOrdenar', 'error', 'a-alert-danger')
              this.disabledDragg = false
            })
        }
      }
    }
  }
}
</script>

<style scoped>
.provisional-margin {
  margin-top: 50px !important;
}
</style>
